import { Component, MouseEvent } from 'react';
import cx from 'classnames';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { Segment, VerticalSpacer } from './../core/core';
import { lockWithPreviewUnlessHasAny } from '../lockDecorators';
import SpinnerOverlay from '../SpinnerOverlay';
import { TableReportCard } from './../CurriculumDashboard/TableReport';
import {
  getInitial,
  getReadableUnixTimeAnsi,
  getReadableUnixTimeMonthDateOnly,
  getWeekRangeFromUnix,
  msInADay,
  msInAWeek,
} from './../GlobalFunctions';
import StudentProfileModalBodyHeader from '../ClassroomDashboard/StudentProfileModalBodyHeader';
import { selectClassroom } from '../Classrooms';
import { expireSessionAndRedirect } from './../aaa';
import MarketingMoodBoard from '../ClassroomDashboard/MarketingMoodBoard';
import {
  getClassroomFeelingsCheckins,
  isMixpanelQueryOnlyReportsEnabled,
  queryMixpanelByGroupV2,
} from '../BackendInterface';
import {
  colorMap,
  generateBarChart,
  generateBarChartData,
  getClassGameData,
  getDayOfWeekFrom,
  moodMap,
} from '../ClassroomDashboard/PeekavilleDataHelpers';
import {
  getClassroomMoodScript,
  getGameProgressQueryStartDate,
  transformMoodEventsToElementaryJournalData,
} from './reportUtilities';
import { HintIcon } from '../HintIcon';
import styles from './../SCSS/ClassroomDashboard.module.scss';
import utilityStyles from './../SCSS/common/utilityStyles.module.scss';
import segmentStyles from './../SCSS/Segment.module.scss';
import MoodboardElementaryMobile from './MoodboardElementaryMobile/MoodboardElementaryMobile';
import SecondaryButton from './../components/SecondaryButton/SecondaryButton';
import PrimaryButton from './../components/PrimaryButton/PrimaryButton';
import classroomAvatar from '../images/classroomAvatar.png';
import silhouette from '../images/pkp-user-grey.svg';
import happyEmoji from '../images/Happy-Emoji.png';
import okayEmoji from '../images/OK-Emoji.png';
import sadEmoji from '../images/Sad-Emoji.png';
import student1 from '../images/student1.png';
import student2 from '../images/student2.png';
import student3 from '../images/student3.png';
import student4 from '../images/student4.png';
import { useHistory } from 'react-router-dom';
import { useErrorStatus } from '../components/EnableErrorMessagePopup/EnableErrorMessagePopup';
import { ExternalLink } from '../components/ExternalLink';
import { RootState } from '../ApplicationState';
import libraryStyles from '../SCSS/Library.module.scss';
import { AxiosAugmentedError, ErrorType } from '../AugmentedError';
import { Dialog, DialogContent } from '../components/Dialog';

interface GameData {
  firstName: string;
  lastName: string;
  berries: number;
  booksCompleted: number;
  questsCompleted: [number, number];
}
interface StudentProgressData {
  userIdHash: string;
  firstName: string;
  lastName: string;
  gameData: {
    berries: number;
    units: Array<{
      bookComplete: boolean;
      questComplete: boolean;
    }>;
  };
}
interface StudentJournalData {
  classroomId: string;
  firstName: string;
  journals: {
    'journal#1': { createdAt: number; feeling?: number };
    'journal#2': { createdAt: number; feeling?: number };
    'journal#3': { createdAt: number; feeling?: number };
    'journal#4': { createdAt: number; feeling?: number };
    'journal#5': { createdAt: number; feeling?: number };
    'journal#6': { createdAt: number; feeling?: number };
    'journal#7': { createdAt: number; feeling?: number };
  };
  lastName: string;
  userIdHash: string;
}
const mapStateToProps = (state: RootState) => ({
  classrooms: {
    state: state.classrooms.state,
    list: state.classrooms.classrooms,
    selectedClassroom: state.classrooms.selectedClassroom,
  },
  classroom: selectClassroom(state),
  userProfile: state.user.userProfile,
});
type MoodBoardStateProps = ReturnType<typeof mapStateToProps>;

interface NameDisplayToggleProps {
  className: string;
  isHideNames: boolean;
  hideNames: () => void;
  showNames: () => void;
}
const NameDisplayToggle = ({ className, isHideNames, hideNames, showNames }: NameDisplayToggleProps) => {
  return isHideNames ? (
    <PrimaryButton small className={className} onClick={showNames}>
      Show Names
    </PrimaryButton>
  ) : (
    <PrimaryButton small className={className} onClick={hideNames}>
      Hide Names
    </PrimaryButton>
  );
};

interface StudentProfileModalBodyProps {
  studentName: string;
  profilePicture: string;
  journalHistory: Record<string, unknown>;
}
class StudentProfileModalBody extends Component<StudentProfileModalBodyProps, Record<string, never>> {
  render() {
    const studentName = this.props.studentName?.trim() || 'Student';
    const initials = getInitial(studentName) || 'S';

    return (
      <div className={styles.studentProfileModalBody}>
        <div className='flex items-center gap-[1.2rem]'>
          {this.props.profilePicture ? (
            <img
              alt='Profile'
              src={this.props.profilePicture}
              className='!left-0 !top-0 h-[6rem] w-[6rem] rounded-full object-cover'
            />
          ) : (
            <div className='flex h-[6rem] w-[6rem] items-center justify-center rounded-full bg-[#00a3d3] font-bold text-white'>
              {initials}
            </div>
          )}
          <div className='text-[2.2rem] font-black text-[#242424]'>{studentName}</div>
        </div>
        <StudentProfileModalBodyHeader journalHistory={this.props.journalHistory} />
      </div>
    );
  }
}

let currentDay0: number[] = [];
let currentDay1: number[] = [];
let currentDay2: number[] = [];
let currentDay3: number[] = [];
let currentDay4: number[] = [];
let currentDay5: number[] = [];
let currentDay6: number[] = [];

const availableQuests = 2; // TEMPORARY FIX. Dependent on how we structure save data later on.

function resetCurrentDayArrays() {
  currentDay0 = [];
  currentDay1 = [];
  currentDay2 = [];
  currentDay3 = [];
  currentDay4 = [];
  currentDay5 = [];
  currentDay6 = [];
}

export async function getClassJournals(
  classroomId: string,
  districtId: string,
  schoolId: string,
  tableOverride?: string,
) {
  const useMixpanel = await isMixpanelQueryOnlyReportsEnabled(districtId, schoolId);

  if (useMixpanel) {
    //
    // NEW PATH: query Mixpanel journal-mood-log events for this classroom.
    // Mood values are strings from Mixpanel — no numeric conversion needed.
    // The query is floored to the gameProgressMixpanel cutover date.
    //
    try {
      const today = new Date().toISOString().split('T')[0];
      const fromDate = getGameProgressQueryStartDate('2023-08-01');
      const script = getClassroomMoodScript(classroomId, fromDate, today);
      const events = await queryMixpanelByGroupV2(script, 'unified');
      const journalData = transformMoodEventsToElementaryJournalData(events);
      return { output: journalData };
    } catch (error) {
      if ((error as AxiosAugmentedError).code === ErrorType.UNAUTHORIZED) {
        expireSessionAndRedirect();
      } else {
        throw error;
      }
    }
  } else {
    //
    // LEGACY PATH: DynamoDB classroom feelings check-ins.
    // Retained for rollback capability behind the feature flag.
    //
    try {
      const results = await getClassroomFeelingsCheckins(classroomId, tableOverride);
      return {
        output: results,
      };
    } catch (error) {
      if ((error as AxiosAugmentedError).code === ErrorType.UNAUTHORIZED) {
        expireSessionAndRedirect();
      } else {
        throw error;
      }
    }
  }
}

interface MoodBoardOwnProps {
  classroomId: string;
  userId: string;
  tableOverride?: string;
  onShowErrorMessage: (message: string) => any;
}
type MoodBoardProps = MoodBoardStateProps & MoodBoardOwnProps;
interface MoodBoardState {
  dataGenerated: boolean;
  showStudentProfileModal: boolean;
  showStudentMoodTooltip: boolean;
  showTalkRequestTooltip: boolean;
  dataIndex: number;
  isStudentRegistered: boolean;
  isHideNames: boolean;
  selectedClassroomIndex?: boolean;
}
class MoodBoard extends Component<MoodBoardProps, MoodBoardState> {
  classGameData: Record<string, GameData>;
  classSize: number;
  journalData: any[];
  talkRequestXValue: number;
  talkRequestYValue: number;
  talkRequestBy: string;
  talkRequestDate: string | number;
  journalHistory: Record<string, unknown>;
  selectedStudentName: string;
  selectedStudentPictureUrl: string;
  studentbooksCompleted: number;
  studentBookOpened: number;
  studentBerriesNum: number;
  studentquestsCompleted: number[];
  moodXValue: number;
  moodYValue: number;
  selectedMood: string;
  selectedMoodMsg: string;
  dataEnteredTime: number;
  day0: string;
  day1: string;
  day2: string;
  day3: string;
  day4: string;
  day5: string;
  day6: string;
  constructor(props: MoodBoardProps) {
    super(props);

    this.state = {
      dataGenerated: false,
      showStudentProfileModal: false,
      showStudentMoodTooltip: false,
      showTalkRequestTooltip: false,
      dataIndex: 0,
      isStudentRegistered: true,
      isHideNames: false,
    };
    this.onProfileClick = this.onProfileClick.bind(this);
    this.studentProfile = this.studentProfile.bind(this);
    this.handleOnModalHide = this.handleOnModalHide.bind(this);
    this.onHideMoodTooltip = this.onHideMoodTooltip.bind(this);
    this.moodValue = this.moodValue.bind(this);
    this.toggleTalkRequest = this.toggleTalkRequest.bind(this);
    this.shiftWeek = this.shiftWeek.bind(this);
    this.generateGameData = this.generateGameData.bind(this);
    this.generateJournalData = this.generateJournalData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleHideNames = this.handleHideNames.bind(this);
    this.handleShowNames = this.handleShowNames.bind(this);
  }

  componentDidMount() {
    if (this.props.classroomId) this.loadData(this.props.classroomId);
  }

  componentDidUpdate(prevProps: MoodBoardProps) {
    if (prevProps.classroomId !== this.props.classroomId) {
      this.loadData(this.props.classroomId);
    }
  }

  loadData(classroomId: MoodBoardProps['classroomId']) {
    if (!classroomId) return;

    this.setState({ dataGenerated: false });
    getClassGameData(
      classroomId,
      this.props.userProfile?.district || '',
      this.props.userProfile?.schoolId || '',
      this.props.tableOverride,
    )
      .then(async (outputArray) => {
        this.classGameData = this.generateGameData(outputArray.output);
        return await getClassJournals(
          classroomId,
          this.props.userProfile?.district || '',
          this.props.userProfile?.schoolId || '',
          this.props.tableOverride,
        );
      })
      .then((outputArray) => {
        resetCurrentDayArrays();
        this.classSize = this.props.classroom.listOfStudentProxies
          ? this.props.classroom.listOfStudentProxies.length
          : 0;
        this.journalData = this.generateJournalData(outputArray.output);
        this.journalData.sort((a, b) => {
          const keyA = a.weekRange[0];
          const keyB = b.weekRange[0];
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        this.setState({
          dataGenerated: true,
          dataIndex: this.journalData.length - 1,
        });
      })
      .catch((err) => {
        if (err.status && err.status === 401) expireSessionAndRedirect();
        this.setState({ dataGenerated: true });
        this.props.onShowErrorMessage(`There was a problem loading your data. Please try again.`);
      });
  }

  shouldLoadData(nextProps) {
    if (nextProps.session.selectedClassroomIndex !== this.state.selectedClassroomIndex) return true;
    return !this.state.dataGenerated;
  }

  toggleTalkRequest(state: boolean, event: MouseEvent, RequestDate: string | number, studentName: string) {
    this.talkRequestXValue = event.pageX;
    this.talkRequestYValue = event.pageY;
    this.talkRequestDate = RequestDate;
    this.talkRequestBy = studentName;
    this.setState({ showTalkRequestTooltip: state });
  }

  moodValue(cellValue, rowValue) {
    const mood = cellValue[0];
    const isNoCheckIn = mood === 'No check-in';
    return (
      <div
        className={cx(styles.moodValue, { [styles.moodValueEmpty]: isNoCheckIn })}
        style={
          isNoCheckIn
            ? undefined
            : {
                backgroundColor: colorMap[mood][0],
                color: colorMap[mood][1],
              }
        }
        onClick={(event) => {
          this.onMoodValueClick(event, cellValue, rowValue.studentName);
        }}
        role='button'
        tabIndex={0}
      >
        {mood}
      </div>
    );
  }

  shiftWeek(direction: string) {
    let newIndex = 0;
    if (direction === 'next') {
      newIndex = this.state.dataIndex + 1;
    } else {
      newIndex = this.state.dataIndex - 1;
    }
    if (newIndex < 0) {
      newIndex = 0;
    }
    if (newIndex > this.journalData.length - 1) {
      newIndex = this.journalData.length - 1;
    }
    this.setState({ dataIndex: newIndex });
  }

  onProfileClick(journalHistory) {
    this.journalHistory = {};
    if (this.state.isHideNames) {
      this.selectedStudentName = 'Private';
      this.selectedStudentPictureUrl = '';
    } else {
      this.selectedStudentName = Array.isArray(journalHistory.studentName)
        ? journalHistory.studentName[0]
        : journalHistory.studentName;
      this.selectedStudentPictureUrl = journalHistory.studentName[1];
    }
    this.studentbooksCompleted = journalHistory.booksCompleted;
    this.studentBookOpened = journalHistory.bookOpened;
    this.studentBerriesNum = journalHistory.berriesNum;
    this.studentquestsCompleted = journalHistory.questsCompleted;
    this.journalHistory.day0 = journalHistory.day0;
    this.journalHistory.day1 = journalHistory.day1;
    this.journalHistory.day2 = journalHistory.day2;
    this.journalHistory.day3 = journalHistory.day3;
    this.journalHistory.day4 = journalHistory.day4;
    this.journalHistory.day5 = journalHistory.day5;
    this.journalHistory.day6 = journalHistory.day6;
    this.setState({
      showStudentProfileModal: true,
    });
  }

  onHideMoodTooltip() {
    this.setState({
      showStudentMoodTooltip: false,
    });
  }

  onMoodValueClick(event: MouseEvent, moodValue: any[], studentInfo: string[]) {
    this.moodXValue = event.pageX;
    this.moodYValue = event.pageY;
    this.selectedMood = moodValue[0];
    this.selectedMoodMsg = moodValue[2];
    this.dataEnteredTime = moodValue[1];
    this.selectedStudentName = studentInfo[0];
    this.selectedStudentPictureUrl = studentInfo[1];

    this.setState({
      showStudentMoodTooltip: true,
    });
  }

  countBooksCompleted(gameData: StudentProgressData['gameData']) {
    if (!gameData) return 0;
    let booksCompleteCount = 0;
    gameData.units.forEach((unit) => {
      if (unit.bookComplete) ++booksCompleteCount;
    });
    return booksCompleteCount;
  }

  countQuestsCompleted(gameData: StudentProgressData['gameData']) {
    if (!gameData) return 0;
    let questsCompleteCount = 0;
    gameData.units.forEach((unit) => {
      if (unit.questComplete) ++questsCompleteCount;
    });
    return questsCompleteCount;
  }
  generateGameData(outputArray: StudentProgressData[]) {
    const classGameData = {};
    outputArray.forEach((studentData) => {
      const gameData = studentData.gameData;
      classGameData[studentData.userIdHash] = {
        firstName: studentData.firstName,
        lastName: studentData.lastName,
        berries: gameData.berries,
        booksCompleted: this.countBooksCompleted(gameData),
        questsCompleted: [this.countQuestsCompleted(gameData), availableQuests],
      };
    });
    return classGameData;
  }

  generateJournalData(outputArray: StudentJournalData[]) {
    const journalData = [];
    const classGameData = this.classGameData;
    const classroomStudentsByUserId = new Map(
      (this.props.classroom?.listOfStudentProxies || []).map((student) => [student.userId, student]),
    );

    // Back-fill enrolled students who have NO mood check-in events at all. The
    // Mixpanel path only returns students who triggered a journal-mood-log
    // event, so a disengaged student would otherwise be omitted entirely (no
    // row, no placeholder). This restores the roster fall-back that the legacy
    // DynamoDB path provided via addStudentsWithNoEntries(). New students are
    // inserted before the empty-check below so that a class where no student
    // has EVER checked in still renders a full table of "No check-in" rows
    // instead of the no-data empty state.
    //
    // The new Mixpanel path returns entries with empty firstName/lastName and
    // userIdHash set to the raw userId; the legacy DynamoDB path returns md5
    // hashed userIdHash with populated names. Mirror the detection used by
    // getStudentLists so roster students are matched on both paths.
    const firstOutputEntry = outputArray[0];
    const useIdMatch = Boolean(firstOutputEntry && firstOutputEntry.userIdHash && !firstOutputEntry.firstName);
    const rosterStudentsWithNoEntries = (this.props.classroom?.listOfStudentProxies || []).filter((student) => {
      if (useIdMatch) {
        return !outputArray.some((entry) => entry.userIdHash === student.userId);
      }
      const normalizedName = (firstName: string, lastName = '') =>
        `${firstName} ${lastName}`.replace(/\s+/g, '').toLowerCase();
      return !outputArray.some(
        (entry) =>
          normalizedName(entry.firstName || '', entry.lastName) ===
          normalizedName(student.firstName || '', student.lastName || ''),
      );
    });
    rosterStudentsWithNoEntries.forEach((student) => {
      outputArray.push({
        userIdHash: student.userId,
        firstName: student.firstName || '',
        lastName: student.lastName || '',
        journals: {},
      } as StudentJournalData);
    });

    if (outputArray.length === 0) return journalData;
    // populate the renderable journalData with explicit journal entries
    outputArray.forEach((studentInfo) => {
      const values = Object.values(studentInfo.journals);
      if (values.length) {
        values.forEach((journalEntry) => {
          const entry = {
            userIdHash: studentInfo.userIdHash,
            studentName: [getDisplayName(studentInfo)],
            data: journalEntry,
          };

          insertWeekly(entry);
        });
      }
    });

    // insert any blank weeks in between data or current date since we want to display this info
    // start by inserting a blank week if there're no entries for current week so we can get the ones in
    // between later
    const currStartOfWeek = getWeekRangeFromUnix(Date.now())[0];
    if (currentDay0[currentDay0.length - 1] !== currStartOfWeek) {
      insertEmptyWeek(currStartOfWeek);
    }

    // now check if there any blank weeks in between data
    const weekBeginnings = currentDay0.slice();
    for (let i = 1; i < weekBeginnings.length; ++i) {
      const oneWeekLater = weekBeginnings[i - 1] + msInAWeek;
      if (weekBeginnings[i] !== oneWeekLater) {
        // there may be more than one week missing
        // Math.round() takes care of start and end of daylight saving time changes
        const weeksMissing = Math.round((weekBeginnings[i] - oneWeekLater) / msInAWeek);
        for (let w = 0; w < weeksMissing; ++w) {
          insertEmptyWeek(oneWeekLater + msInAWeek * w);
        }
      }
    }

    // scan through students and find students who don't have an etry for any
    // particular week and create dummy entries for that week
    const weekRanges = journalData.map((weekly) => weekly.weekRange);
    outputArray.forEach((studentInfo) => {
      weekRanges.forEach((range) => {
        if (hasNoEntriesIn(range, studentInfo)) {
          insertDummyEntryForWeekly(studentInfo, range[0] + 60 * 60 * 5);
        }
      });
    });

    return journalData;

    function hasNoEntriesIn(range: number[], studentInfo) {
      const values = Object.values(studentInfo.journals);
      if (!values.length) return true;

      let foundEntryInThisWeekRange = false;
      values.forEach((journalEntry) => {
        const entryWeekRange = getWeekRangeFromUnix(journalEntry.createdAt);
        if (isWeekRangeEqual(range, entryWeekRange)) foundEntryInThisWeekRange = true;
      });

      return !foundEntryInThisWeekRange;
    }

    function insertDummyEntryForWeekly(studentInfo, timeStamp: number) {
      const entry = {
        userIdHash: studentInfo.userIdHash,
        studentName: [getDisplayName(studentInfo)],
        // Use string 'No check-in' so it works with both the legacy numeric
        // path (moodMap[0] === 'No check-in') and the new string Mixpanel path.
        data: { createdAt: timeStamp, feeling: 'No check-in' },
      };

      insertWeekly(entry);
    }

    // inserts a week with no entries into the journal data, where startofweek is some
    // time (in unix) within the week trying to be inserted
    function insertEmptyWeek(startOfWeek: number) {
      const newWeekly = [];
      newWeekly.weekRange = getWeekRangeFromUnix(startOfWeek);
      journalData.push(newWeekly);
      updateDateArray(newWeekly.weekRange[0]);
    }

    function insertWeekly(entry) {
      const entryWeekRange = getWeekRangeFromUnix(entry.data.createdAt);

      const existingWeekly = journalData.find((weekly) => isWeekRangeEqual(weekly.weekRange, entryWeekRange));

      if (existingWeekly) {
        insertIndividual(existingWeekly, entry);
      } else {
        const newWeekly = [];
        newWeekly.weekRange = entryWeekRange;
        insertIndividual(newWeekly, entry);
        journalData.push(newWeekly);
        updateDateArray(entryWeekRange[0]);
      }
    }

    function getInsertionIndex(weekly, studentName) {
      let i = 0;
      while (i < weekly.length && weekly[i].studentName < studentName) ++i;
      return i;
    }

    function insertIndividual(weekly, entry) {
      const existingIndividual = weekly.find((individual) => isIndividualEqual(individual, entry));

      if (existingIndividual) {
        createEntryData(existingIndividual, entry);
      } else {
        const studentData = classGameData[entry.userIdHash];
        let newIndividual = {
          userIdHash: entry.userIdHash,
          studentName: entry.studentName,
          /*  bookOpened: 0,  */
          booksCompleted: studentData ? studentData.booksCompleted : 0,
          berriesNum: studentData ? studentData.berries : 0,
          questsCompleted: studentData ? studentData.questsCompleted : [0, availableQuests],
          talkRequest: [false],
        };

        newIndividual = createEntryData(newIndividual, entry);
        weekly.splice(getInsertionIndex(weekly, newIndividual.studentName), 0, newIndividual);
      }

      function createEntryData(individual, e) {
        const dayOfWeek = getDayOfWeekFrom(e.data.createdAt);
        const aliasOfIndividual = individual;
        const prevEntry = individual[`day${dayOfWeek}`];
        // check if an existing entry is newer and should not be overwritten
        if (prevEntry && e.data.createdAt < prevEntry[1]) return;
        // When feeling is already a string (Mixpanel new path) use it directly;
        // when it's a number (DynamoDB legacy path) look it up in moodMap.
        const moodLabel = typeof e.data.feeling === 'string' ? e.data.feeling : moodMap[e.data.feeling];
        aliasOfIndividual[`day${dayOfWeek}`] = [moodLabel, e.data.createdAt];
        return aliasOfIndividual;
      }
    }

    function isIndividualEqual(individual1, individual2) {
      return individual1.userIdHash === individual2.userIdHash;
    }

    function isWeekRangeEqual(weekRange1, weekRange2) {
      return weekRange1[0] === weekRange2[0] && weekRange1[1] === weekRange2[1];
    }

    function getDisplayName(studentInfo) {
      const fullName = `${studentInfo.firstName || ''} ${studentInfo.lastName || ''}`.trim();
      if (fullName) {
        return fullName;
      }

      const gameDataForStudent = classGameData[studentInfo.userIdHash];
      const fullNameFromGameData =
        `${gameDataForStudent?.firstName || ''} ${gameDataForStudent?.lastName || ''}`.trim();
      if (fullNameFromGameData) {
        return fullNameFromGameData;
      }

      const classroomStudent = classroomStudentsByUserId.get(studentInfo.userIdHash);
      const fullNameFromClassroom = `${classroomStudent?.firstName || ''} ${classroomStudent?.lastName || ''}`.trim();
      if (fullNameFromClassroom) {
        return fullNameFromClassroom;
      }

      return 'Student';
    }
  }

  handleOnModalHide() {
    this.setState({
      showStudentProfileModal: false,
    });
  }

  handleHideNames() {
    this.setState({
      isHideNames: true,
    });
  }

  handleShowNames() {
    this.setState({
      isHideNames: false,
    });
  }

  render() {
    if (this.isLocked()) {
      return <MarketingMoodBoard />;
    }

    if (!this.state.dataGenerated) {
      return <SpinnerOverlay isShow={true} />;
    }

    const currentData = this.journalData;
    if (currentData) {
      this.tableData = currentData[this.state.dataIndex];
    }

    this.day0 = getReadableUnixTimeMonthDateOnly(currentDay0[this.state.dataIndex]);
    this.day1 = getReadableUnixTimeMonthDateOnly(currentDay1[this.state.dataIndex]);
    this.day2 = getReadableUnixTimeMonthDateOnly(currentDay2[this.state.dataIndex]);
    this.day3 = getReadableUnixTimeMonthDateOnly(currentDay3[this.state.dataIndex]);
    this.day4 = getReadableUnixTimeMonthDateOnly(currentDay4[this.state.dataIndex]);
    this.day5 = getReadableUnixTimeMonthDateOnly(currentDay5[this.state.dataIndex]);
    this.day6 = getReadableUnixTimeMonthDateOnly(currentDay6[this.state.dataIndex]);

    this.barChartData = generateBarChartData(this.tableData, currentDay0[this.state.dataIndex]);

    const showPreviousWeekChevron = () => {
      /* only show if there exists a previous week */
      return (
        currentData &&
        currentData[this.state.dataIndex - 1] && (
          <div>
            <i
              className='fa fa-angle-left'
              style={{
                cursor: 'pointer',
                zIndex: '10',
                bottom: '-15px',
                left: '0px',
              }}
              onClick={() => {
                this.shiftWeek('previous');
              }}
            />
          </div>
        )
      );
    };

    const showNextWeekChevron = () => {
      /* only show if there exists a next week */
      return (
        currentData &&
        currentData[this.state.dataIndex + 1] && (
          <div>
            <i
              className='fa fa-angle-right'
              style={{
                cursor: 'pointer',
                zIndex: '10',
                bottom: '-15px',
                right: '-20px',
              }}
              onClick={() => {
                this.shiftWeek('next');
              }}
            />
          </div>
        )
      );
    };

    const displayTable = () => {
      return this.state.dataGenerated && this.tableData ? (
        <div className={styles.MoodBoardTable} style={{ width: '95%', margin: '0 auto' }}>
          <div className={styles.moodboardBanner}>Weekly Overview — Moodboard</div>
          <TableReportCard
            data={this.tableData || []}
            id1='studentName'
            id2='day0'
            id3='day1'
            id4='day2'
            id5='day3'
            id6='day4'
            id7='day5'
            id8='day6'
            width1='16%'
            width2='12%'
            width3='12%'
            width4='12%'
            width5='12%'
            width6='12%'
            width7='12%'
            width8='12%'
            column1='Student'
            column2={this.day0}
            column3={this.day1}
            column4={this.day2}
            column5={this.day3}
            column6={this.day4}
            column7={this.day5}
            column8={this.day6}
            id1Format={this.studentProfile}
            id2Format={this.moodValue}
            id3Format={this.moodValue}
            id4Format={this.moodValue}
            id5Format={this.moodValue}
            id6Format={this.moodValue}
            id7Format={this.moodValue}
            id8Format={this.moodValue}
            trClassName={(_data, rowIndex) =>
              cx(styles.studentRow, rowIndex % 2 === 0 ? styles.studentRowStripe : undefined)
            }
          />
        </div>
      ) : (
        <div className={styles.noTableData}>
          {this.state.dataGenerated ? (
            <div className={styles.emptyEntry}>
              <div className={styles.emptyEntryMessage}>
                <p>Hmm, it looks like your students haven&apos;t submitted any entries yet.</p>
                <p>
                  Have any students checked-in in{' '}
                  <ExternalLink className={libraryStyles.textLink} href='https://mypeekaville.com' target='_blank'>
                    myPeekaville
                  </ExternalLink>
                  ?
                </p>
              </div>
              <div className={styles.studentAvatarsLine}>
                <img alt='Student 1' src={student1} />
                <img alt='Student 2' src={student2} />
                <img alt='Student 3' src={student3} />
                <img alt='Student 4' src={student4} />
                <ExternalLink className={styles.faqButtonLink} href='https://help.peekapak.com' target='_blank'>
                  <SecondaryButton small className={styles.faqButton}>
                    READ FAQs
                  </SecondaryButton>
                </ExternalLink>
              </div>
            </div>
          ) : (
            <SpinnerOverlay isShow={!this.state.dataGenerated} />
          )}
        </div>
      );
    };

    return (
      <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
        <Segment className={cx(utilityStyles.line, styles.topLine)}>
          <div className={styles.titleLine}>
            <div className={styles.title}>
              <div className={styles.tiitleAndIcon}>
                <p className={segmentStyles.moduleTitle}>Mood Board</p>
                <HintIcon>
                  How does the Mood Board work? Read this{' '}
                  <ExternalLink href='http://blog.peekapak.com/feelings-check-in-tool/' target='_blank'>
                    article
                  </ExternalLink>{' '}
                  to find out.
                </HintIcon>
              </div>
              <MediaQuery maxWidth={767}>
                <div className={styles.ClassroomSizeMobile}>
                  <img alt='User silhouette' src={silhouette} />
                  Class Size: {this.classSize}
                </div>
              </MediaQuery>
            </div>
            <NameDisplayToggle
              className={styles.hideAndShowNamesButton}
              isHideNames={this.state.isHideNames}
              hideNames={this.handleHideNames}
              showNames={this.handleShowNames}
            />
          </div>
        </Segment>
        <VerticalSpacer ems={2} />
        {this.state.isStudentRegistered ? (
          <>
            <MediaQuery minWidth={768}>
              <div className={styles.MoodBoard}>
                <div className={styles.barChartAndClassInfo}>
                  <div className={styles.ClassroomInfo}>
                    <div className={styles.ClassroomAvatar}>
                      <img alt='Avatar' src={classroomAvatar} />
                    </div>
                    <div className={styles.ClassroomSize}>
                      <img alt='User silhouette' src={silhouette} />
                      Class Size: {this.classSize}
                    </div>
                  </div>
                  <div className={styles.BarChart}>
                    <div className={styles.title}>WEEKLY OVERVIEW</div>
                    <div className={styles.chartBase}>
                      <div className={styles.happyRow}>
                        <img alt='Happy' src={happyEmoji} />
                        <hr />
                      </div>
                      <div className={styles.neutralRow}>
                        <img alt='OK' src={okayEmoji} />
                        <hr />
                      </div>
                      <div className={styles.sadRow}>
                        <img alt='Sad' src={sadEmoji} />
                        <hr />
                      </div>
                      <div className={styles.elementsRow}>
                        <div className={styles.width} />
                        <div className={styles.elements}>{generateBarChart(this.barChartData)}</div>
                        <div className={styles.width} />
                      </div>
                    </div>
                    <div className={styles.weekRow}>
                      <div className={styles.width}>{showPreviousWeekChevron()}</div>
                      <div className={styles.dateSpan}>
                        <div className={styles.Date}>Sun</div>
                        <div className={styles.Date}>Mon</div>
                        <div className={styles.Date}>Tue</div>
                        <div className={styles.Date}>Wed</div>
                        <div className={styles.Date}>Thu</div>
                        <div className={styles.Date}>Fri</div>
                        <div className={styles.Date}>Sat</div>
                      </div>
                      <div className={styles.width}>{showNextWeekChevron()}</div>
                    </div>
                  </div>
                </div>
                {displayTable()}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
              <MoodboardElementaryMobile
                barChartData={this.barChartData}
                currentData={currentData}
                dataGenerated={this.state.dataGenerated}
                isHideNames={this.state.isHideNames}
                onClickStudentName={(entry) => this.onProfileClick(entry)}
                tableData={this.tableData}
                showNextWeekNav={currentData && currentData[this.state.dataIndex + 1]}
                showPreviousWeekNav={currentData && currentData[this.state.dataIndex - 1]}
                shiftWeekPrevious={() => this.shiftWeek('previous')}
                shiftWeekNext={() => this.shiftWeek('next')}
              />
            </MediaQuery>
          </>
        ) : (
          <div className={styles.emptyMoodBoard}>
            <div className={styles.section1}>
              Oh no, there are no students registered for this classroom.
              <SecondaryButton small>
                <i className='fa fa-phone' />
                Call Us at 1-800-800-1234 to Setup
              </SecondaryButton>
            </div>
            <div className={styles.section2}>
              Read our FAQ guide to learn more
              <ExternalLink href='https://help.peekapak.com' target='_blank'>
                <SecondaryButton small>READ FAQs</SecondaryButton>
              </ExternalLink>
            </div>
          </div>
        )}

        <Dialog
          open={this.state.showStudentProfileModal}
          onOpenChange={(isOpen) => {
            if (!isOpen) {
              this.handleOnModalHide();
            }
          }}
        >
          <DialogContent
            className='w-[min(92vw,860px)] rounded-[0.8rem] border-0 bg-white p-0 text-left text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
            overlayClassName='bg-black/50'
          >
            <div className='relative px-[1.2rem] pb-[0.6rem] pt-[1rem]'>
              <button
                type='button'
                aria-label='Close'
                onClick={this.handleOnModalHide}
                className='absolute right-[0.8rem] top-[0.8rem] flex h-[2.6rem] w-[2.6rem] items-center justify-center rounded-full border-0 bg-transparent p-0 text-[2.2rem] leading-none text-slate-600 outline-none transition-colors hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus-visible:ring-1 focus-visible:ring-slate-300'
              >
                ×
              </button>
            </div>
            <div className='px-[1.6rem] pb-[1.6rem] pt-0'>
              <StudentProfileModalBody
                studentName={this.selectedStudentName}
                profilePicture={this.selectedStudentPictureUrl}
                journalHistory={this.journalHistory}
              />
            </div>
          </DialogContent>
        </Dialog>

        {this.state.showStudentMoodTooltip ? (
          <div
            className={styles.moodTooltip}
            style={{
              top: `${this.moodYValue}px`,
              left: `${this.moodXValue}px`,
            }}
          >
            <div className={styles.moodTooltipHeader}>Journal Entry -</div>
            <hr />
            <div
              className={styles.studentProfileOnTable}
              style={{
                left: '30px',
                marginBottom: '20px',
                width: '50%',
                float: 'left',
              }}
            >
              {this.selectedStudentPictureUrl && (
                <img alt='Selected student' src={this.state.isHideNames ? '' : this.selectedStudentPictureUrl} />
              )}
            </div>
            <div
              className={styles.mood}
              style={{
                backgroundColor: colorMap[this.selectedMood][0],
                color: colorMap[this.selectedMood][1],
              }}
            >
              {this.selectedMood}
            </div>
            <div className={styles.tex}>{this.selectedMoodMsg}</div>
            {this.dataEnteredTime ? (
              <div className={styles.date}>Submitted at {getReadableUnixTimeAnsi(this.dataEnteredTime)}</div>
            ) : (
              <div className={styles.date}>No journal message was entered</div>
            )}
            <button
              type='button'
              className={`button ${styles['button-blue-moodToolTip']}`}
              onClick={() => {
                this.onHideMoodTooltip();
              }}
            >
              OK
            </button>
          </div>
        ) : null}

        {this.state.showTalkRequestTooltip ? (
          <div
            className={styles.talkRequestTooltip}
            style={{
              top: `${this.talkRequestYValue}px`,
              left: `${this.talkRequestXValue}px`,
            }}
          >
            {this.talkRequestBy} wants to talk to you on {this.talkRequestDate}
          </div>
        ) : null}
        <VerticalSpacer ems={5} />
      </div>
    );
  }

  gotoFaqs = () => window.open('https://help.peekapak.com', '_blank');

  studentProfile(cellValue, rowValue) {
    if (this.state.isHideNames) {
      return (
        <div className={styles.studentProfileOnTable} tabIndex={0}>
          <div
            className={cx(styles.avatarAndName, styles.rowNavigable)}
            onClick={() => {
              this.onProfileClick(rowValue);
            }}
            role='button'
          >
            <div className={styles.hiddenName}>Private</div>
            <span className={styles.rowChevron} aria-hidden='true'>
              ›
            </span>
          </div>
        </div>
      );
    }

    const rawStudentName = Array.isArray(cellValue) ? cellValue[0] : cellValue;
    const studentName = (rawStudentName || '').trim() || 'Student';

    return (
      <div className={styles.studentProfileOnTable} tabIndex={0}>
        {!rowValue.talkRequest[0] ? (
          <div
            className={styles.requestBadge}
            onMouseEnter={(event) => this.toggleTalkRequest(true, event, rowValue.talkRequest[1], studentName)}
            onMouseLeave={(event) => this.toggleTalkRequest(false, event, rowValue.talkRequest[1], studentName)}
          >
            <i className='fa fa-commenting-o' />
          </div>
        ) : null}
        <div
          className={cx(styles.avatarAndName, styles.rowNavigable)}
          onClick={() => {
            this.onProfileClick(rowValue);
          }}
          role='button'
        >
          <div className={styles.studentAvatar}>{getInitial(studentName)}</div>
          <div className={styles.studentName}>{studentName}</div>
          <span className={styles.rowChevron} aria-hidden='true'>
            ›
          </span>
        </div>
      </div>
    );
  }
}

function updateDateArray(firstDayOfWeek) {
  currentDay0.push(firstDayOfWeek);
  currentDay0.sort();
  currentDay1.push(firstDayOfWeek + msInADay);
  currentDay1.sort();
  currentDay2.push(firstDayOfWeek + msInADay * 2);
  currentDay2.sort();
  currentDay3.push(firstDayOfWeek + msInADay * 3);
  currentDay3.sort();
  currentDay4.push(firstDayOfWeek + msInADay * 4);
  currentDay4.sort();
  currentDay5.push(firstDayOfWeek + msInADay * 5);
  currentDay5.sort();
  currentDay6.push(firstDayOfWeek + msInADay * 6);
  currentDay6.sort();

  /* Leave for debugging
  console.log( `${ JSON.stringify( currentDay0.map( d =>
      [ new Date( d ).toString(), d ] ), null, 2 ) }` );
      **/
}

function ClassFunctionWrapper(props: MoodBoardProps) {
  const history = useHistory();
  const onShowErrorMessage = useErrorStatus();
  const LockingMoodBoard = lockWithPreviewUnlessHasAny(
    'KEY_MOODBOARD',
    'KEY_PEEKAPAK_MANAGEMENT',
    'KEY_WIP',
    'KEY_MASTER_KEY',
  )(MoodBoard);
  return <LockingMoodBoard {...props} history={history} onShowErrorMessage={onShowErrorMessage} />;
}

export default connect(mapStateToProps, null)(ClassFunctionWrapper);
